<template>
    <v-dialog v-model="dialog" persistent width="70%">
      
      <v-card>
        <v-container>
        
          <!-- <p class=".title ma-2">Travel Party</p> -->
          <v-card-title>Travel Party</v-card-title>
          <v-form ref="hehoTravelParty">
  
            <v-row no-gutters>
              <v-col cols="6">
                <v-select v-model="heho.heho_aant_volw" :items="heho_aant_volwKeuzes" item-value="volw_nr"
                  item-text="volw_oms" :label="heho.heho_aant_volw_label" @change="calcTravelParty" class="travelpadd">
                </v-select>
              </v-col>
              <v-col cols="6">
                <v-select v-model="heho.heho_aant_kind" :items="heho_aant_kindKeuzes" item-value="kind_nr"
                  item-text="kind_oms" :label="heho.heho_aant_kind_label" @change="calcTravelParty" class="travelpadd">
                </v-select>
              </v-col>
            </v-row>
  
            <v-row no-gutters>
              <v-col cols="6">
                <v-select v-model="heho.heho_aant_baby" :items="heho_aant_babyKeuzes" item-value="baby_nr"
                  item-text="baby_oms" :label="heho.heho_aant_baby_label" @change="calcTravelParty" class="travelpadd">
                </v-select>
              </v-col>
              <v-col cols="6">
                <v-select v-model="heho.heho_aant_hd" :items="heho_aant_hdKeuzes" item-value="hd_nr" item-text="hd_oms"
                  :label="heho.heho_aant_hd_label" @change="calcTravelParty" class="travelpadd"></v-select>
              </v-col>
            </v-row>
            
            <v-row no-gutters>
              <v-col cols="6">
              Extra fields needed for Feratel
              </v-col>
            </v-row>
            
            <v-row no-gutters>
              <v-col cols="6">
                <v-select v-model="heho.heho_klnt_land" :items="heho.heho_klnt_landKeuzes" item-value="land_code"
                  item-text="land_oms" label="Country" class="travelpadd">
                </v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="heho.heho_klnt_postcode" label="Postal code" class="travelpadd"></v-text-field>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="6">
                <v-text-field v-model="heho.heho_klnt_email" label="Customer email" class="travelpadd"></v-text-field>
              </v-col>
              <v-col cols="6">
                
              </v-col>
            </v-row>
            




            <v-row no-gutters>
              <v-col cols="12">
                <div class="pa-4">
                  <span v-html="heho.invoiceUitleg"></span>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <div class="pa-4">
                  <span v-html="heho.onsiteUitleg"></span>
                </div>
              </v-col>
            </v-row>
  
            <div class="br_small"></div>
            <v-container>
              <v-row cols="12" dense>
                <!-- <v-col cols="1" class="pa-1"><label>Main booker</label></v-col> -->
                <!-- <v-col cols="1" class="pa-1"><label>Salutation</label></v-col> -->
                <v-col cols="3" class="pa-1"><label>First name</label></v-col>
                <v-col cols="2" class="pa-1"><label>Last name</label></v-col>
              
                <v-col cols="1" align="right" class="pr-6">M. booker</v-col>
            
                <v-col cols="1" class="pa-1"><label>Date of birth</label></v-col>
                <v-col cols="1" class="pa-1"><label>Age on arrival</label></v-col>
                <v-col cols="1" class="pa-1"><label>Doc. type</label></v-col>
                <v-col cols="2" class="pa-1"><label>Document number</label></v-col>
                <span v-if="this.allowExtraPerson">
                  <v-col cols="1" class="pa-1"><v-avatar  size="20" color="success" class="avatar-ptr margin-btn-lft" v-on:click="addEmptyLine()"><v-icon small color="white">mdi-plus</v-icon></v-avatar></v-col>
                </span>
                <span v-else>
                  <v-col cols="1" class="pa-1"><v-avatar  size="20" color="blue-grey lighten-4" class="avatar-ptr margin-btn-lft"><v-icon small color="white">mdi-plus</v-icon></v-avatar></v-col>
                </span>
              </v-row>
              <v-row colls="11" dense>
                <v-col cols="11">
              <v-divider></v-divider>
              <!-- <v-divider></v-divider> -->
            </v-col>
              </v-row>
              <div class="br_small"></div>
              <v-row cols="12" v-for="(person, idx) in heho_hegs" :key="idx" dense>
                <!-- <v-col cols="1" class="pa-1">                 -->
                  <!-- <v-simple-checkbox v-model.lazy="person.hogs_hoofd_gast" label="" dense class="mb-3"></v-simple-checkbox> -->
                <!-- </v-col>               -->
                <!-- <v-col cols="1" class="pa-1">
                  <v-select v-model.lazy="person.hogs_aanh_code" label="" single-line :items="aanh_codeKeuzes" item-value="aanh_code" item-text="aanhtaal_oms" dense></v-select>
                </v-col> -->
                <v-col cols="3" class="pa-1">
                  <v-text-field v-model="person.hegs_voornaam" label="" dense v-bind:rules="hegs_naamRules"></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-layout justify-start>
                  <v-text-field v-model="person.hegs_naam" label="" dense v-bind:rules="hegs_naamRules"></v-text-field>
                  <v-spacer></v-spacer>
                  <v-checkbox v-model.lazy="person.hegs_hoofd_gast" label="" dense hide-details class="shrink pr-3" v-on:click="setMainBooker(person)"></v-checkbox> 
                </v-layout>
                </v-col>
                <v-col cols="1" class="pa-1">
                  <v-text-field v-model.lazy="person.hegs_geb_dat" :value="refactorDate(person)" label="" dense v-bind:rules="hegs_geb_datRules"></v-text-field>
                </v-col>
                <v-col cols="1" class="pa-1">
                  <v-text-field :value="calculateAge(person)" label="" readonly dense class="def"></v-text-field>
                </v-col>
                <v-col cols="1" class="pa-1">
                  <v-select v-model.lazy="person.hegs_id_type" label="" single-line :items="id_codekeuzes" item-value="code" item-text="desc" dense></v-select>
                </v-col>
                <v-col cols="2" class="pa-1">
                  <v-text-field v-model="person.hegs_id_nr" label="" dense></v-text-field>
                </v-col>
                <!--place action buttons here (clear and delete)-->
                
                <v-col cols="1" class="pa-1">
                  <v-layout right-justify>
                  <v-btn icon x-small v-on:click="clearItem(person.key)" class="margin-btn">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                    <v-btn icon x-small v-on:click="deleteItem('key', person.key)" class="margin-btn">
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-layout>
                </v-col>
            
              </v-row>
            </v-container>
            <div class="br_small"></div>
            <div v-if="inSync()">
              <v-row dense no-gutters>
                <v-col cols="12" class="pl-4 success">
                  <span class="white--text">
                    <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-check-circle-outline</v-icon>Travelparty synchronized
                  </span>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <v-row dense no-gutters>
                <v-col cols="12" class="pl-4 warning">
                  <span class="white--text">
                    <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-alert-circle-outline</v-icon>Travelparty not synchronized
                  </span>
                </v-col>
              </v-row>
            </div>
            
            <div v-if="this.heho.feratel_acco">
            <div v-if="this.heho.Feratel_guid">
              <v-row dense no-gutters>
                <v-col cols="8" class="pl-4 mt-1 info">
                  <span class="white--text">
                    <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-outline</v-icon>Feratel preregistration done: {{this.heho.Feratel_guid}}
                  </span>
                </v-col>
                <v-col cols="4" class="pl-4 mt-1 info text-right">
                  <v-btn v-if="!this.heho.Feratel_mblattnr" x-small color="primary" class="mt-1 mr-4" @click="updFeratel('convert'); loader = 'loading'" :loading="loading">Convert to registration</v-btn>
                  <v-dialog v-if="!this.heho.Feratel_mblattnr" v-model="cancelpreregdialog" width="500" >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="red lighten-2 mt-1 mr-4"  x-small dark v-bind="attrs" v-on="on" :loading="loading">
                        Cancel 
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Are you sure you want to cancel?
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="updFeratel('cancel_pre'); loader = 'loading'; cancelpreregdialog = false">Yes</v-btn>
                        <v-btn color="secondary" @click="cancelpreregdialog = false">NO</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row> 
            </div>
            <div v-if="this.heho.Feratel_mblattnr">
              <v-row dense no-gutters>
                <v-col cols="6" class="pl-4 mt-1 info">
                  <span class="white--text">
                    <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-text-outline</v-icon>Feratel registration done: {{this.heho.Feratel_mblattnr}}
                    
                  </span>
                </v-col>
                <v-col cols="6" class="pl-4 mt-1 info text-right">
                  <v-btn v-if="this.heho.feratel_registration && this.heho.feratel_guestcard !== 'No Guestcards' && this.heho.feratel_guestcard !== 'Guestcards sent automatic' && this.heho.feratel_guestcard !== 'Guestcards sent manually' && !this.heho.feratel_guestcard_processed" x-small color="primary" class="mt-1 mr-4" :href="'https://visitortax.deskline.net/Services.asmx/PrintVTForm?betriebnr=' + this.heho.Feratel_betriebnr +'&oestat=' + this.heho.Feratel_oestat + '&companyCode=' + this.heho.Feratel_CompanyCode + '&sheetNumber=' + this.heho.Feratel_mblattnr" target="_blank" :loading="loading">Print Visitor registration form</v-btn>
                  <v-btn v-if="this.heho.feratel_registration && this.heho.feratel_guestcard !== 'No Guestcards' && this.heho.feratel_guestcard !== 'Visitor registration sent automatic' && this.heho.feratel_guestcard !== 'Visitor registration sent manually' && !this.heho.feratel_guestcard_processed" x-small color="primary" class="mt-1 mr-4" :href="'https://visitortax.deskline.net/Services.asmx/PrintGuestCard?betriebnr=' + this.heho.Feratel_betriebnr +'&oestat=' + this.heho.Feratel_oestat + '&companyCode=' + this.heho.Feratel_CompanyCode + '&sheetNumber=' + this.heho.Feratel_mblattnr + '&printMainGuestOnly=false'" target="_blank" :loading="loading">Print Guest cards</v-btn>
                  <v-btn v-if="this.heho.feratel_extra" x-small color="primary" class="mt-1 mr-4" @click="updFeratel('departure'); loader = 'loading'" :loading="loading">Finalize registration</v-btn>
                  <v-dialog v-if="this.heho.feratel_registration" v-model="cancelregdialog" width="600" >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="red lighten-2 mt-1 mr-4"  x-small dark v-bind="attrs" v-on="on" :loading="loading">
                        Cancel 
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Are you sure you want to Cancel this registration?
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="updFeratel('cancel'); loader = 'loading'; cancelregdialog = false">Yes</v-btn>
                        <v-btn color="secondary" @click="cancelregdialog = false">No</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row> 
            </div>
            <div v-if="this.heho.Feratel_mblattnr == '' && this.heho.Feratel_guid == '' && this.heho.feratel_registration">
              <v-row dense no-gutters>
                <v-col cols="4" class="pl-4 mt-1 info">
                  <span class="white--text">
                    <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-outline</v-icon>Feratel </span>
                </v-col>
                <v-col cols="8" class="pl-4 mt-1 info text-right">
                  <v-btn v-if="this.heho.Feratel_mblattnr == '' && this.heho.Feratel_guid == '' && this.heho.feratel_registration" x-small color="primary" class="mt-1 mr-4" @click="updFeratel('registration_final'); loader = 'loading'" :loading="loading">Create final registration</v-btn>
                  <v-btn v-if="this.heho.Feratel_guid == '' && this.heho.Feratel_mblattnr == '' && this.heho.feratel_extra" x-small color="primary" class="mt-1 mr-4" @click="updFeratel('preregistration'); loader = 'loading'" :loading="loading">Create preregistration</v-btn>
                </v-col>
              </v-row> 
            </div>
            <div v-if="this.heho.Feratel_CompanyCode != '' && this.heho.feratel_extra">
              <v-row dense no-gutters>
                <v-col cols="4" class="pl-4 mt-1 info">
                  <span class="white--text">
                    <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-outline</v-icon>Feratel Extra Tests</span>
                </v-col>
                <v-col cols="8" class="pl-4 mt-1 info text-right">
                  <v-btn x-small color="secondary" class="mt-1 mr-4" @click="updFeratel('convert'); loader = 'loading'" :loading="loading">Convert preregistration</v-btn>
                  <v-btn x-small color="secondary" class="mt-1 mr-4" @click="updFeratel('departure'); loader = 'loading'" :loading="loading">Set departure date</v-btn>
                  <v-btn x-small color="secondary" class="mt-1 mr-4" @click="updFeratel('registration_final'); loader = 'loading'" :loading="loading">Create final registration</v-btn>
                  <v-btn x-small color="secondary" class="mt-1 mr-4" @click="updFeratel('update'); loader = 'loading'" :loading="loading">Update data</v-btn>
                </v-col>
              </v-row> 
            </div>
            <div>
              <v-row dense no-gutters>
                <v-col cols="8" class="pl-4 mt-1 info">
                  <span class="white--text">
                    <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-outline</v-icon>Feratel Guest card processing type: {{ this.heho.feratel_guestcard }}</span>
                </v-col>
                <v-col cols="4" class="pl-4 mt-1 info text-right">
                  <v-checkbox v-if="this.heho.feratel_guestcard !== 'No Guestcards'" color="white" v-model="heho.feratel_guestcard_processed"  @click="updFeratel('process_guestcard');">
                    <template v-slot:label>
                      <span style="color:white">
                        Guestcard sent to guest
                      </span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row> 
            </div>
            </div>  
            <v-row dense no-gutters>
              <v-col cols="12" class="pa-4 mt-1 red">
                <span class="white--text">Make all the changes to the travel party <B><u>in 1 action</u></B> to prevent too
                  many financial lines in the booking. Booking confirmations are not sent automatically yet. Please send
                  new confirmations manually.</span>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!--
            <div v-if="!this.travelparty_ok">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" class="mx-2">
                    <v-btn color="primary mx-2" small @click="updTravelParty" v-bind="attrs" :disabled="true">Save</v-btn>
                  </div>
                </template>
                <span>Your travel party registration is larger then the number of persons <br>
                  on the booking. They must be equal or less. Travelers {{this.numberOfPersons}}, and number <br>
                  of registrations is {{this.heho_hegs.length}}.</span>
              </v-tooltip>
            </div>          
            <div v-else>
            -->  
            <v-btn color="primary mx-2" small @click="updTravelParty">Save</v-btn>
            <!--
            </div>
            -->  
            <v-btn color="primary" small @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  
  import {bus} from "../../main";
  import moment from 'moment';
  import mxfindwithattribute from '@/mixins/findwithattribute';
  import mxfindwithattributepro from '@/mixins/findwithattributepro';
  
  export default {
    data() { 
      return {
        dialog: false,
        cancelregdialog: false,
        cancelpreregdialog: false,
        heho_encrid: null,
        heho_aant_hdKeuzes: [],
        heho_aant_volwKeuzes: [],
        heho_aant_kindKeuzes: [],
        heho_aant_babyKeuzes: [],
        //aanh_codeKeuzes: [],
        id_codekeuzes: [],
        menuBirthDate:false,
        birthDateDMY:'',    
        birtDataISO:'',
        arrivalDate:'',
        loader: null,
        loading: false,
        numberOfPersonOnStartup:'',
        heho_hegs: [],
        heho: {},
        max_age_child: 17,
        max_age_baby: 2,
        hegs_naamRules: [
            v => (v && v.length >= 2 || (v == '' || v == null)) || "Name needs to have more than 2 characters"
        ],
        hegs_geb_datRules: [
            v => (v && v.length == 10 || (v == '' || v == null)) || "DD-MM-YYYY"
        ],          
      }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]
      },
    },
    computed:{
      numberOfPersons: function(){
        return (parseInt(this.heho.heho_aant_volw) + parseInt(this.heho.heho_aant_kind) + parseInt(this.heho.heho_aant_baby));
      },
      travelparty_ok: function() {
        return this.numberOfPersons >= this.heho_hegs.length;
      },
      allowExtraPerson: function(){
          // return this.heho.huis_pers_max > this.heho_hegs.length;
          // first modify booking by increaing travel party; then you may add extra persons (conform my account)
          return (this.heho.heho_aant_volw + this.heho.heho_aant_kind + this.heho.heho_aant_baby) > this.heho_hegs.length;
      },    
    },
    mixins:[mxfindwithattribute, mxfindwithattributepro],
    methods: {
      open(heho_encrid) {
        var deze = this;
        this.$emit("showSnackbar");
        this.dialog = true;
        this.$axios
          .post("ares/json/ares/heho/getHehoTravelParty.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "getHehoTravelParty",
            },
            getHehoTravelParty: {
              heho_encrid: heho_encrid,
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.heho = res.data.getHehoTravelParty;
              this.max_age_baby = res.data.getHehoTravelParty.max_age_baby;
              this.max_age_child = res.data.getHehoTravelParty.max_age_child;
              res.data.getHehoTravelParty.heho_aant_volwKeuzes.forEach(function (volw) {
                deze.heho_aant_volwKeuzes.push(volw);
              });
              res.data.getHehoTravelParty.heho_aant_kindKeuzes.forEach(function (kind) {
                deze.heho_aant_kindKeuzes.push(kind);
              });
              res.data.getHehoTravelParty.heho_aant_babyKeuzes.forEach(function (baby) {
                deze.heho_aant_babyKeuzes.push(baby);
              });
              res.data.getHehoTravelParty.heho_aant_hdKeuzes.forEach(function (hd) {
                deze.heho_aant_hdKeuzes.push(hd);
              });
              this.numberOfPersonOnStartup = parseInt(this.heho.heho_aant_volw) + parseInt(this.heho.heho_aant_kind) + parseInt(this.heho.heho_aant_baby);
              this.heho_hegs = res.data.getHehoTravelParty.hegs;
              // key zetten, add field to array for screen presentation purposes
              // this.aanh_codeKeuzes = res.data.getHehoTravelParty.aanh;
              this.id_codekeuzes = res.data.getHehoTravelParty.id_types;
              this.arrivalDate = res.data.getHehoTravelParty.iso_arr_dat;
              for (let i = 0; i < this.heho_hegs.length; i++) {
                this.heho_hegs[i].key = i+1;
              }                        
              // console.log(JSON.stringify(this.heho_hegs));
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      deleteItem(attr, attr_value){
        var idx = this.findWithAttr(this.heho_hegs, attr, attr_value);
        if(idx!=-1){
          this.heho_hegs.splice(idx, 1);
        }
      },
      deleteItemPro(attr, attr_val,  attr2, attr_val2, op){
        var idx = this.findWithAttrPro(this.heho_hegs, attr, attr_val, attr2, attr_val2, op);
        if(idx!=-1){
          this.heho_hegs.splice(idx, 1);
        }
      },
      setMainBooker(element){
        var key = element.key;
        console.log(key);
        for (let i = 0; i < this.heho_hegs.length; i++) {
          if (this.heho_hegs[i].key !== key){
            this.heho_hegs[i].hegs_hoofd_gast = false; // switch off all except the current (doesn't matter if it's off or on)
          }
        }       
         
      },
      getEmptyLines() {
        var empty_lines = 0;
        for (let i = 0; i < this.heho_hegs.length; i++) {
          if (this.isEmpty(this.heho_hegs[i])) {
            empty_lines++;
          }
        }
        return empty_lines;
      },
      isEmpty(element){
         return element.hegs_geb_dat === '' &&
                element.hegs_naam === '' &&
                //element.hogs_aanh_oms === '' &&
                //element.hogs_aanh_code === '' &&
                element.hegs_voornaam === '' &&
                element.hegs_id_type === '' &&
                element.hegs_id_type_oms === '' &&
                element.hegs_id_nr === '';
      },
      isValidTravelPartyRegistration(element){
          return (element.hegs_naam !== '' || element.hegs_geb_dat !== '');
      },
      getValidLines(){
        var valid_lines = 0;
        for (let i = 0; i < this.heho_hegs.length; i++) {
          if (this.isValidTravelPartyRegistration(this.heho_hegs[i])) {
            valid_lines++;
          }
        }
        return valid_lines;      
      },
      partyCompositionInSync(){
  
        //console.log(this.heho_hegs.length);
  
        var a = 0; // adults > 17
        var b = 0; // babies < 3
        var c = 0; // children >= 3 <= 17 
  
        for (let i = 0; i < this.heho_hegs.length; i++) {
          // check for empty lines; the generally do not have birthdates :(
          if (this.isValidTravelPartyRegistration(this.heho_hegs[i])){
            if(this.heho_hegs[i].hegs_geb_dat === ''){
              return false;
            } else {
              var element = new Object();
              element.hegs_geb_dat = this.heho_hegs[i].hegs_geb_dat;
              var age = this.calculateAge(element);
              console.log(age, this.max_age_child, this.max_age_baby);
              if(age > this.max_age_child){
                a++;
              } else {
                if(age > this.max_age_baby){
                  c++;
                } else {
                  b++;
                }
              }
            }
          }
        }         
        return this.heho.heho_aant_baby == b &&  // use JS on-the-fly type conversions
               this.heho.heho_aant_kind == c &&
               this.heho.heho_aant_volw == a;
      },
      inSync(){
        return this.getValidLines() === this.numberOfPersons && this.partyCompositionInSync();
      },
      addEmptyLine(){
        var element = new Object();
        element.hegs_geb_dat = '';
        element.hegs_naam = '';
        //element.hegs_aanh_oms = '';
        //element.hegs_aanh_code = '';
        element.hegs_voornaam = '';
        element.hegs_id_type = '';
        element.hegs_id_type_oms = '';
        element.hegs_id_nr = '';
        element.hegs_hoofd_gast = false;
        element.key = this.heho_hegs.length+1; // array = 0 based, length is not so add 1
        this.heho_hegs.push(element);      
      },
  
      clearItem(attr_value){
        var idx = this.findWithAttr(this.heho_hegs, "key", attr_value);
        this.heho_hegs[idx].hegs_geb_dat = '';
        this.heho_hegs[idx].hegs_naam = '';
        //this.heho_hegs[idx].hogs_aanh_code = '';
        //this.heho_hegs[idx].hogs_aanh_oms = '';      
        this.heho_hegs[idx].hegs_voornaam = '';
        this.heho_hegs[idx].hegs_id_type = '';
        this.heho_hegs[idx].hegs_id_type_oms = '';
        this.heho_hegs[idx].hegs_hoofd_gast = false;
        this.heho_hegs[idx].hegs_id_nr = '';
      },
      notifyHeho(param) {
        bus.$emit("reloadHeho", param);
      },       
      calculateAge(item) {
        let isodate1;
        if (item.hegs_geb_dat != '' && item.hegs_geb_dat.length === 10) {
          try {
            let date1 = item.hegs_geb_dat.split("-");
            if(date1.length != 3){
              console.log("invalid format date format (accepted: DD-MM-YYYY)");
            } else {
              isodate1 = date1[2] + "-" + date1[1] + "-" + date1[0];
            }
          } catch (err) {
            console.log("invalid format date format (accepted: DD-MM-YYYY)");
            return ''; // no age can be determined 
          }
        } else {        
          return ''; // no age can be determined 
        }
        var a = moment(isodate1);
        var b = moment(this.arrivalDate);
        return "" + Math.abs(a.diff(b, 'years')); // trick to create a string value 
      },    
      refactorDate(person){
        let refdat = person.hegs_geb_dat;
        if(refdat.length === 10 ){
          refdat = refdat.replace("/", "-");
          refdat = refdat.replace(":", "-");
          refdat = refdat.replace(",", "-");
          refdat = refdat.replace("_", "-");
          refdat = refdat.replace(".", "-");
          person.hegs_geb_dat = refdat;
        }
      },  
      calcTravelParty() {
        this.$axios
          .post("ares/json/ares/heho/calcTravelParty.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "calcTravelParty",
            },
            calcTravelParty: {
              heho_encrid: this.heho.heho_encrid,
              heho_aant_volw: parseInt(this.heho.heho_aant_volw),
              heho_aant_kind: parseInt(this.heho.heho_aant_kind),
              heho_aant_baby: parseInt(this.heho.heho_aant_baby),
              heho_aant_hd: parseInt(this.heho.heho_aant_hd),
              english: true
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.heho.invoiceUitleg = res.data.calcTravelParty.invoiceUitleg;
              this.heho.onsiteUitleg = res.data.calcTravelParty.onsiteUitleg;
  
              let xlength = (this.numberOfPersons - this.numberOfPersonOnStartup); // difference in old and new numbers
  
              // console.log(xlength);
  
              if (xlength > 0) { // + persons 
                xlength -= this.getEmptyLines(); // do not create empty lines we already have...
                for (let i = 0; i < xlength; i++) { // add empty one(s) as needed, if an empty line can be found there is no need to add a new one
                  // console.log('create empty line');
                  this.addEmptyLine();
                }
              }
              else { // - persons  
                for (let i = 0; i < Math.abs(xlength); i++) { // try to delete empty one(s) if they can be found
                  this.deleteItemPro('hegs_naam', '', 'hegs_geb_dat', '', 'and');
                }
                for (let i = 0; i < this.heho_hegs.length; i++) { // regenerate keys to avoid gaps
                  this.heho_hegs[i].key = i + 1;
                }
              }
  
              this.numberOfPersonOnStartup = this.numberOfPersons;
  
            }
          });
      },
      updTravelParty() {
        // console.log(this.heho_hegs);
        this.$axios
          .post("ares/json/ares/heho/updTravelParty.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "updTravelParty",
            },
            updTravelParty: {
              heho_encrid: this.heho.heho_encrid,
              heho_aant_volw: parseInt(this.heho.heho_aant_volw),
              heho_aant_kind: parseInt(this.heho.heho_aant_kind),
              heho_aant_baby: parseInt(this.heho.heho_aant_baby),
              heho_aant_hd: parseInt(this.heho.heho_aant_hd),
              heho_klnt_email: this.heho.heho_klnt_email,
              heho_klnt_land: this.heho.heho_klnt_land,
              heho_klnt_postcode: this.heho.heho_klnt_postcode,
              heho_hegs: this.heho_hegs,
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.updTravelParty.text,
                color: res.data.updTravelParty.color,
              });
              if (res.data.updTravelParty.color == "success" || res.data.updTravelParty.color == "warning" ) {
                this.notifyHeho("travelparty");
              }
              this.dialog = false;
            }
          });
      },
      updFeratel(action){
        //console.log("Feratel",action,this.heho.Feratel_guid, this.heho.Feratel_mblattnr);
        this.$axios
          .post("ares/json/ares/heho/updFeratel.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "updFeratel",
            },
            updFeratel: {
              heho_encrid: this.heho.heho_encrid,
              feratel_guestcard_processed: this.heho.feratel_guestcard_processed,
              action: action
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.updFeratel.text,
                color: res.data.updFeratel.color,
              });
              this.heho.Feratel_mblattnr = res.data.updFeratel.feratel_mblattnr;
              this.heho.Feratel_guid = res.data.updFeratel.feratel_guid;
              //this.heho.feratel_guestcard_processed = res.data.updFeratel.feratel_guestcard_processed;
              
              this.loader = null;
              this.loading = false;
              //this.dialog = false;
            }
          });
      }
    },
  };
  </script>
  
  <style scoped>
    .br_small {
        display: block;
        margin-bottom: 1em;
    }
    .def {
      cursor: default;
    }  
    .travelpadd {
      padding-left: 16px;
      padding-right: 16px;
    }
  .margin-btn {
      margin-top: 10px;
      margin-left: 10px;
  }  
  .margin-btn-lft {
      margin-left: 10px;
  }  
  .avatar-ptr {
      cursor: pointer;
    }    
  </style>
  
  